import { FilterMatchMode } from 'primereact/api';

export class MonitoreoAlerta {
    constructor() {
        this.model = {
            fecha_crea: {
                header: 'Fecha Detección',
                table: true,
                sort: true,
                isDate: true,
                filter: true,
                style: { minWidth: '120px', fontSize: '0.8rem' },
                body: (rowData) => {
                    return (
                        <div className="flex flex-column">
                            <span className="font-medium">{new Date(rowData.fecha_crea).toLocaleDateString()}</span>
                            <small className="text-500">{new Date(rowData.fecha_crea).toLocaleTimeString()}</small>
                        </div>
                    );
                }
            },
            periodo: {
                header: 'Periodo Alerta',
                table: true,
                sort: true,
                sortField: 'periodo',
                filter: false,
                style: { minWidth: '120px' },
                body: (rowData) => {
                    const formatDate = (dateString) => {
                        if (!dateString) return '-'; //  dateString viene como "2025-05-30"
                        const [year, month, day] = dateString.split('-');
                        return new Date(year, month - 1, day).toLocaleDateString();
                    };

                    return (
                        <div className="flex flex-column gap-1" style={{ fontSize: '0.8rem' }}>
                            <div className="flex align-items-center">
                                <span className="text-500 mr-2" style={{ width: '25px', fontSize: '0.75rem' }}>Desde: </span>
                                <span className="font-medium text-700">
                                    {formatDate(rowData.fecha_inicio)}
                                </span>
                            </div>
                            <div className="flex align-items-center">
                                <span className="text-500 mr-2" style={{ width: '25px', fontSize: '0.75rem' }}>Hasta: </span>
                                <span className="font-medium text-700">
                                    {formatDate(rowData.fecha_fin)}
                                </span>
                            </div>
                        </div>
                    );
                }
            },
            cliente_nombre: {
                header: 'Cliente / Sujeto',
                table: true,
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '150px' },
                body: (rowData) => (
                    <div className="flex flex-column">
                        <span className="font-bold text-900" style={{ fontSize: '0.9rem' }}>{rowData.cliente_nombre}</span>
                        <small className="text-500">{rowData.cliente_identificacion}</small>
                    </div>
                )
            },
            configuracion_nombre: {
                header: 'Regla Activada',
                table: true,
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '180px' },
                body: (rowData) => {
                    const ruleStyles = {
                        'REG_SUPERA_UMBRAL': {
                            color: '#ef4444',
                            bgColor: '#fee2e2',
                            icon: 'pi pi-exclamation-circle'
                        },
                        'REG_EXCESO_TRANSACCIONES': {
                            color: '#8b5cf6',
                            bgColor: '#f5f3ff',
                            icon: 'pi pi-bolt'
                        },
                        'REG_MEDIO_PAGO': {
                            color: '#3b82f6',
                            bgColor: '#eff6ff',
                            icon: 'pi pi-credit-card'
                        }
                    };
                    const style = ruleStyles[rowData.alerta_nemonico] || { color: '#64748b', bgColor: '#f1f5f9', icon: 'pi pi-shield' };

                    return (
                        <div className="flex align-items-center gap-2 px-2 py-1 border-round" style={{ backgroundColor: style.bgColor, borderLeft: `4px solid ${style.color}`, width: 'fit-content' }}>
                            <i className={style.icon} style={{ color: style.color, fontSize: '0.8rem' }}></i>
                            <div className="flex flex-column">
                                <span className="font-bold" style={{ fontSize: '0.8rem', color: '#334155' }}>
                                    {rowData.configuracion_nombre}
                                </span>
                            </div>
                        </div>
                    );
                }
            },
            evidencia: {
                header: 'Evidencia de Alerta',
                table: true,
                sort: false,
                filter: false,
                style: { minWidth: '180px' },
                body: (rowData) => {
                    if (rowData.alerta_nemonico === 'REG_SUPERA_UMBRAL') {
                        return (
                            <div className="flex flex-column" style={{ fontSize: '0.75rem' }}>
                                <span>Monto: <b className="text-danger">${rowData.monto_transaccionado}</b></span>
                                <span>Umbral: <small>${rowData.monto_genera_alerta}</small></span>
                            </div>
                        );
                    }
                    if (rowData.alerta_nemonico === 'REG_EXCESO_TRANSACCIONES') {
                        return (
                            <div className="flex flex-column" style={{ fontSize: '0.75rem' }}>
                                <span>Transacciones: <b className="text-danger">{rowData.num_transacciones_realizadas}</b></span>
                                <span>Máx. permitido: <small>{rowData.num_transacciones_max}</small></span>
                            </div>
                        );
                    }
                    if (rowData.alerta_nemonico === 'REG_MEDIO_PAGO') {
                        return (
                            <div className="flex flex-column">
                                <span className="font-bold text-900" style={{ fontSize: '0.85rem' }}>
                                    {rowData.metodo_pago || 'No especificado'}
                                </span>
                                <small className="text-500">
                                    Código transacción: <span className="font-medium text-primary">{rowData.transaccion_codigo || 'S/N'}</span>
                                </small>
                            </div>
                        );
                    }

                    return <span className="text-sm">{'Análisis de Perfil'}</span>;
                }
            },
            estado_nombre: {
                header: 'Estado Alerta',
                table: true,
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                style: { minWidth: '160px' },
                body: (rowData) => {
                    const statusConfig = {
                        'ESTADO_ALERTA_NUEVA': {
                            color: '#e24c4c',
                            bgColor: '#fff1f1',
                            icon: 'pi pi-bell',
                            borderColor: '#f87171'
                        },
                        'ESTADO_ALERTA_REVISION': {
                            color: '#f59e0b',
                            bgColor: '#fffbeb',
                            icon: 'pi pi-list',
                            borderColor: '#fbbf24'
                        },
                        'ESTADO_ALERTA_VISUALIZADA': {
                            color: '#0ea5e9',
                            bgColor: '#f0f9ff',
                            icon: 'pi pi-eye',
                            borderColor: '#38bdf8'
                        },
                        'ESTADO_ALERTA_MATRIZ_FINALIZADA': {
                            color: '#7c3aed',
                            bgColor: '#f5f3ff',
                            icon: 'pi pi-file-check',
                            borderColor: '#8b5cf6'
                        },
                        'ESTADO_ALERTA_EN_MATRIZ': {
                            color: '#475569',
                            bgColor: '#f1f5f9',
                            icon: 'pi pi-table',
                            borderColor: '#94a3b8'
                        },
                        'ESTADO_ALERTA_FALSO_POSITIVO': {
                            color: '#64748b',
                            bgColor: '#f8fafc',
                            icon: 'pi pi-times-circle',
                            borderColor: '#94a3b8'
                        }
                    };
                    const nemonico = rowData.estado_nemonico;
                    const config = statusConfig[nemonico] || { color: '#6b7280', bgColor: '#f3f4f6', icon: 'pi pi-question-circle', borderColor: '#9ca3af' };

                    return (
                        <div className="flex flex-column gap-1">
                            <div
                                className="flex align-items-center gap-2 px-3 py-1"
                                style={{ backgroundColor: config.bgColor, borderRadius: '5px', border: `1px solid ${config.borderColor}`, width: 'fit-content', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                                <i className={config.icon} style={{ color: config.color, fontSize: '0.8rem' }}></i>
                                <span className="font-bold" style={{ color: config.color, fontSize: '0.8rem', letterSpacing: '0.5px', whiteSpace: 'nowrap' }}>
                                    {rowData.estado_nombre}
                                </span>
                            </div>

                            {rowData.matriz_codigo && (
                                <div className="pl-1 mt-1">
                                    <small className="text-600" style={{ fontSize: '0.75rem' }}>
                                        Código de matriz: <span className="text-800 font-medium">{rowData.matriz_codigo}</span>
                                    </small>
                                </div>
                            )}
                        </div>
                    );
                }
            },
            usuario_asignado: {
                header: 'Analista Asignado',
                table: true,
                sort: true,
                filter: true,
                style: { minWidth: '150px' },
                body: (rowData) => (
                    <div className="flex align-items-center gap-2">
                        <i className="pi pi-user text-400" style={{ fontSize: '0.8rem' }}></i>
                        <span className="text-sm text-600">{rowData.usuario_asignado_nombre || 'Sin asignar'}</span>
                    </div>
                )
            }
        };
    }

    // Plantilla del reporte de alertas
    static getReportTemplate(data, info) {
        const COLORS = {
            headerBg: '#f8fafc',
            zebraBg: '#f1f5f9',
            border: '#e2e8f0',
            textMain: '#1e293b',
            textLight: '#64748b',
            textDanger: '#dc2626',
            primary: '#0f172a',
            alertaNueva: '#e24c4c',
            alertaRevisada: '#f59e0b',
            alertaVisualizada: '#0ea5e9',
            alertaMatrizFin: '#7c3aed',
            alertaEnMatriz: '#475569',
            alertaFalsa: '#64748b'
        };

        // Helper para Fecha y Hora (Columna Detección)
        const formatDateTime = (dateString) => {
            if (!dateString) return '-';
            const d = new Date(dateString);
            return `${d.toLocaleDateString()}\n${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
        };

        // Helper solo para Fecha (Columna Periodo)
        const formatDateOnly = (dateString) => {
            if (!dateString) return '-';
            return new Date(dateString).toLocaleDateString();
        };

        const formatCurrency = (val) => {
            if (val === null || val === undefined) return '';
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val);
        };

        // Lógica de evidencia
        const buildEvidenciaContent = (row) => {
            const stack = [];
            switch (row.alerta_nemonico) {
                case 'REG_SUPERA_UMBRAL':
                    stack.push({
                        text: [{ text: 'Monto: ', style: 'evidenceLabel' }, { text: formatCurrency(row.monto_transaccionado), style: 'textDangerBold' }],
                        margin: [0, 0, 0, 2]
                    });
                    stack.push({
                        text: [{ text: 'Umbral: ', style: 'evidenceSub' }, { text: formatCurrency(row.monto_genera_alerta), style: 'evidenceSub' }]
                    });
                    break;
                case 'REG_EXCESO_TRANSACCIONES':
                    stack.push({
                        text: [{ text: 'Transacciones: ', style: 'evidenceLabel' }, { text: row.num_transacciones_realizadas, style: 'textDangerBold' }],
                        margin: [0, 0, 0, 2]
                    });
                    stack.push({
                        text: [{ text: 'Máx. permitido: ', style: 'evidenceSub' }, { text: row.num_transacciones_max, style: 'evidenceSub' }]
                    });
                    break;
                case 'REG_MEDIO_PAGO':
                    stack.push({
                        text: row.metodo_pago || 'No especificado',
                        style: 'evidenceMain',
                        margin: [0, 0, 0, 2]
                    });
                    stack.push({
                        text: [{ text: 'Código trans: ', style: 'evidenceSub' }, { text: row.transaccion_codigo || 'S/N', style: 'evidenceSubPrimary' }]
                    });
                    break;
                default:
                    stack.push({ text: 'Análisis de Perfil', style: 'evidenceSub' });
                    break;
            }
            return stack;
        };

        const getStateColor = (nemonico) => {
            const map = {
                'ESTADO_ALERTA_NUEVA': COLORS.alertaNueva,
                'ESTADO_ALERTA_REVISION': COLORS.alertaRevisada,
                'ESTADO_ALERTA_VISUALIZADA': COLORS.alertaVisualizada,
                'ESTADO_ALERTA_MATRIZ_FINALIZADA': COLORS.alertaMatrizFin,
                'ESTADO_ALERTA_EN_MATRIZ': COLORS.alertaEnMatriz,
                'ESTADO_ALERTA_FALSO_POSITIVO': COLORS.alertaFalsa,
            };
            return map[nemonico] || COLORS.textLight;
        };

        const buildTableBody = (records) => {
            const body = [];
            // Header de la tabla (7 Columnas ahora)
            body.push([
                { text: 'DETECCIÓN', style: 'tableHeader' },
                { text: 'PERIODO', style: 'tableHeader' }, // Nueva columna
                { text: 'CLIENTE / SUJETO', style: 'tableHeader' },
                { text: 'REGLA ACTIVADA', style: 'tableHeader' },
                { text: 'EVIDENCIA', style: 'tableHeader' },
                { text: 'ESTADO', style: 'tableHeader' },
                { text: 'ASIGNADO', style: 'tableHeader' }
            ]);

            records.forEach((row, index) => {
                const isZebra = index % 2 === 1;
                const fill = isZebra ? COLORS.zebraBg : null;

                body.push([
                    { text: formatDateTime(row.fecha_crea), style: 'cellDate', fillColor: fill },
                    {
                        stack: [
                            {
                                text: [
                                    { text: 'Desde: ', color: COLORS.textLight, fontSize: 7 },
                                    { text: formatDateOnly(row.fecha_inicio), fontSize: 8, bold: true, color: COLORS.textMain }
                                ]
                            },
                            {
                                text: [
                                    { text: 'Hasta: ', color: COLORS.textLight, fontSize: 7 },
                                    { text: formatDateOnly(row.fecha_fin), fontSize: 8, bold: true, color: COLORS.textMain }
                                ],
                                margin: [0, 2, 0, 0]
                            }
                        ],
                        fillColor: fill
                    },
                    {
                        stack: [
                            { text: row.cliente_nombre, style: 'cellBold' },
                            { text: row.cliente_identificacion, style: 'cellSub' }
                        ],
                        fillColor: fill
                    },
                    { text: row.configuracion_nombre || 'Regla sin nombre', style: 'cellText', fillColor: fill },
                    { stack: buildEvidenciaContent(row), fillColor: fill },
                    {
                        stack: [
                            {
                                text: row.estado_nombre,
                                style: 'cellStatus',
                                color: getStateColor(row.estado_nemonico)
                            },
                            row.matriz_codigo ? {
                                text: `Matriz: ${row.matriz_codigo}`,
                                fontSize: 7,
                                color: '#64748b',
                                margin: [0, 2, 0, 0]
                            } : {}
                        ],
                        fillColor: fill
                    },
                    {
                        text: row.usuario_asignado_nombre || 'Sin Asignar',
                        style: row.usuario_asignado_nombre ? 'cellText' : 'cellItalic',
                        color: row.usuario_asignado_nombre ? COLORS.textMain : COLORS.textLight,
                        fillColor: fill
                    }
                ]);
            });
            return body;
        };

        // Definición del documento
        return {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            pageMargins: [20, 20, 20, 40],

            footer: (currentPage, pageCount) => ({
                columns: [
                    { text: `Usuario: ${info.usuario_generador || 'Sistema'}`, style: 'footerText', width: '30%' },
                    { text: `Total registros: ${data.length}`, style: 'footerText', alignment: 'center', width: '*' },
                    { text: `Página ${currentPage} de ${pageCount}`, alignment: 'right', style: 'footerText', width: '30%' }
                ],
                margin: [20, 10, 20, 0]
            }),

            content: [
                // BLOQUE DE TÍTULO
                {
                    margin: [0, 0, 0, 10],
                    columns: [
                        {
                            width: '*',
                            columns: [
                                {
                                    width: 'auto',
                                    stack: info.logo ? [{ image: info.logo, width: 60, margin: [0, 0, 10, 0] }] : []
                                },
                                {
                                    width: '*',
                                    text: info.razon_social,
                                    style: 'brand',
                                    margin: [0, 15, 0, 0]
                                }
                            ]
                        },
                        {
                            width: 'auto',
                            stack: [
                                { text: 'REPORTE OPERATIVO DE ALERTAS', style: 'reportTitle' },
                                { text: `Generado el: ${new Date().toLocaleString()}`, style: 'reportMeta' },
                                { text: `Rango: ${info.fecha_inicio} al ${info.fecha_fin}`, style: 'reportMeta' }
                            ],
                            alignment: 'right'
                        }
                    ]
                },
                // TABLA DE DATOS
                {
                    table: {
                        headerRows: 1,
                        // PROPORCIONES
                        // 1. Detección (8%)
                        // 2. Periodo (10%)
                        // 3. Cliente (16%)
                        // 4. Regla (15%)
                        // 5. Evidencia (*) - Elástica
                        // 6. Estado (12%)
                        // 7. Asignado (12%)
                        widths: ['8%', '10%', '16%', '15%', '*', '12%', '12%'],
                        body: buildTableBody(data)
                    },
                    layout: {
                        hLineWidth: (i, node) => (i === 0 || i === 1 || i === node.table.body.length) ? 1 : 0.5,
                        vLineWidth: () => 0,
                        hLineColor: (i) => (i === 1) ? COLORS.primary : COLORS.border,
                        paddingLeft: (i) => 4,
                        paddingRight: (i) => 4,
                        paddingTop: (i) => 6,
                        paddingBottom: (i) => 6
                    }
                }
            ],

            styles: {
                brand: { fontSize: 11, bold: true, color: COLORS.textLight },
                reportTitle: { fontSize: 14, bold: true, color: COLORS.primary, margin: [0, 0, 0, 2], font: 'Roboto' },
                reportMeta: { fontSize: 8, color: COLORS.textLight },
                tableHeader: { fontSize: 8, bold: true, color: COLORS.textLight, fillColor: COLORS.headerBg, margin: [0, 4, 0, 4] },

                // Estilos de celda
                cellText: { fontSize: 8.5, color: COLORS.textMain },
                cellBold: { fontSize: 8.5, bold: true, color: COLORS.textMain },
                cellSub: { fontSize: 7.5, color: COLORS.textLight },
                cellDate: { fontSize: 8, color: COLORS.textMain, lineHeight: 1.1 },
                cellStatus: { fontSize: 8, bold: true },
                cellItalic: { fontSize: 8.5, italics: true, color: COLORS.textLight },

                // Evidencia
                evidenceMain: { fontSize: 8.5, bold: true, color: COLORS.textMain },
                evidenceLabel: { fontSize: 8.5, color: COLORS.textMain },
                textDangerBold: { fontSize: 8.5, bold: true, color: COLORS.textDanger },
                evidenceSub: { fontSize: 7.5, color: COLORS.textLight },
                evidenceSubPrimary: { fontSize: 7.5, color: COLORS.alertaVisualizada, bold: true },

                footerText: { fontSize: 8, color: COLORS.textLight }
            },
            defaultStyle: { font: 'Roboto' }
        };
    }
}
